import '../../reset.css';
import '../../general_styles.css';
import './confirmation_styles.css';

import thankIconImg from '../../images/icon-thank-you.svg';

import NavigationMenu from '../../components/Navigation';

function Confirmation() {
    return (
        <div className='page__container'>
            <div className='form__container'>
                <NavigationMenu />
                <div className='confirmation__container'>
                    <img src={thankIconImg} className='confirmation__img'></img>
                    <h2 className='confirmation__title'>Thank you!</h2>
                    <p className='confirmation__text'>Thanks for confirming your subscription! We hope you have fun using our plataform. If you ever need support, please feel free to email us at support@loremgaming.com.</p>
                </div>
            </div>

        </div>
    );

}

export default Confirmation;